import { ReactNode } from 'react';
import cx from 'classnames';

import { useTailwind } from '@/hooks/useTailwind';

import { Alignment } from './API/Alignment';

interface HeaderProps {
    className?: string;
    align?: Alignment;
    children: ReactNode;
}

const Header = ({ className = '', align = 'left', children }: HeaderProps) => {
    const tw = useTailwind(className);

    return (
        <h1 className={cx('font-bold tracking-tight', {
            'text-3xl md:text-5xl': ! tw.hasTextSize(),
            'text-left': align === 'left',
            'text-center': align === 'center',
            'text-right': align === 'right',
            [className]: Boolean(className)
        })}>
            {children}
        </h1>
    );
};

export { Header };